import React from "react";
import "./Checkout.css";
import CheckoutProducts from "./CheckoutProducts";
import Subtotal from "./Subtotal";
import { useStateValue } from "./StateProvider";

const Checkout = () => {
	const [{ basket }, dispatch] = useStateValue();

	return (
		<div className="checkout">
			<div className="checkout__left">
				<img
					className="checkout_adImage"
					src="https://images-eu.ssl-images-amazon.com/images/G/31/img20/Vernac13th/1500x150_V2_Eng._CB412582591_.jpg"
					alt="img"
				/>
				<div>
					<h2 className="checkout__title">Shopping Cart</h2>
					<div className="wrapper__grid">
						{basket.map((item) => (
							<CheckoutProducts
								title={item.title}
								image={item.image}
								price={item.price}
								rating={item.rating}
							/>
						))}
					</div>
				</div>
			</div>
			<div className="checkout__right">
				<Subtotal></Subtotal>
			</div>
		</div>
	);
};

export default Checkout;
